import { Button } from 'foundations-components/transitional/components/Button';
import { ListItem } from 'foundations-components/transitional/components/List';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Flex } from 'foundations-components/components/Flex';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MacroOption = ({
  macro,
  handleSelectMacro
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": `macro-option-button-${macro.id}`,
      onClick: () => handleSelectMacro(macro),
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        inlineSize: "100%",
        children: [macro.name, isHovered && macro.description && /*#__PURE__*/_jsx(HelpIcon, {
          title: macro.description,
          tooltipPlacement: "right",
          "data-test-id": "macro-option-help-icon"
        })]
      })
    })
  });
};
MacroOption.displayName = 'MacroOption';